<template>
	<div id="logoManagement">
		<Loading v-if="loading" :text="'Atualizando'"></Loading>

		<div class="row justify-content-center">
			<div class="col-12 mb-3">
				<h4>Logo</h4>
				<p>
					<small
						>Envie o logo do seu site para layouts claros ou escuros
						e se desejar, em versões menores para celular e
						ícone.</small
					>
				</p>
			</div>
			<div class="col-12 mb-2" v-if="message">
				<span class="succes-message text-success">{{ message }}</span>
			</div>
			<div class="col-12" v-if="!verifyLogo && !modeCrop" @click="$refs.uploadLogo.click()">
				<FileAdd type="big"  />
				<input
					type="file"
					class="d-none"
					ref="uploadLogo"
					@change="handleFile('uploadLogo', 'logo')"
				/>
			</div>
			<div class="row" v-if="verifyLogo && !modeCrop">
				<div class="col-6 mode-light pt-3">
					<div class="row">
						<div class="col-12 mb-3" @click="$refs.uploadLogo.click()" style="cursor: pointer">
							<p class="mb-1">Desktop</p>
							<img
								class="img-fluid logo-item current-logo rounded"
								:src="getUrl('logo')"
								alt
							/>
							<input
								type="file"
								class="d-none"
								ref="uploadLogo"
								@change="handleFile('uploadLogo', 'logo')"
							/>
							<FileAdd
								type="icon"

							/>
						</div>
						<div class="col-12 mb-3" @click="$refs.uploadLogoMobile.click()" style="cursor: pointer">
							<p class="mb-1">Mobile</p>
							<img
								class="img-fluid logo-item current-logo-mobile rounded"
								:src="getUrl('logo_mobile')"
								alt
							/>
							<input
								type="file"
								class="d-none"
								ref="uploadLogoMobile"
								@change="
									handleFile(
										'uploadLogoMobile',
										'logo_mobile'
									)
								"
							/>
							<FileAdd
								type="icon"

							/>
						</div>
						<div class="col-12 mb-3" @click="$refs.uploadFavicon.click()" style="cursor: pointer">
							<p class="mb-1">Favicon</p>
							<img
								class="img-fluid logo-item current-favicon rounded"
								:src="getUrl('favicon')"
								alt
							/>
							<input
								type="file"
								class="d-none"
								ref="uploadFavicon"
								@change="handleFile('uploadFavicon', 'favicon')"
							/>
							<FileAdd
								type="icon"

							/>
						</div>
					</div>
				</div>
				<div class="col-6 mode-dark pt-3">
					<div class="row">
						<div class="col-12 mb-3" @click="$refs.uploadLogoDark.click()" style="cursor: pointer">
							<p class="mb-1">Desktop</p>
							<img
								class="img-fluid logo-item current-logo rounded"
								:src="getUrl('logo_dark')"
								alt
							/>
							<input
								type="file"
								class="d-none"
								ref="uploadLogoDark"
								@change="
									handleFile('uploadLogoDark', 'logo_dark')
								"
							/>
							<FileAdd
								type="icon"

							/>
						</div>
						<div class="col-12 mb-3" @click="$refs.uploadLogoDarkMobile.click()" style="cursor: pointer">
							<p class="mb-1">Mobile</p>
							<img
								class="img-fluid logo-item current-logo rounded"
								:src="getUrl('logo_dark_mobile')"
								alt
							/>
							<input
								type="file"
								class="d-none"
								ref="uploadLogoDarkMobile"
								@change="
									handleFile(
										'uploadLogoDarkMobile',
										'logo_dark_mobile'
									)
								"
							/>
							<FileAdd
								type="icon"

							/>
						</div>
					</div>
				</div>
			</div>
			<div class="row justify-content-center" v-if="modeCrop">
				<div class="col-12 text-center mt-3">
					<div
						class="row align-items-center justify-content-center p-3"
					>
						<p v-if="ext != 'svg'" class="text-center col-12">Escolha a área do logo</p>
						<div class="col-12 mb-3">
              <img 
              class="w-100"
              v-if="ext == 'svg'"
              :src="getUrl(modeCrop)" 
              alt="">
							<ImageCropper
                v-else
								:src="getUrl(modeCrop)"
								@updateCropedUrl="croppedUrl = $event"
							/>
						</div>
						<div class="col-12">
							<button
								class="btn btn-primario btn-small"
								@click.prevent="uploadCropped()"
							>
								Confirmar logo
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 mt-5" v-if="!modeCrop">
				<p>
					Ideal .png tamanhos:<br />
					<small
						>Desktop: 260px do lado maior<br />
						Celular: 200px do lado maior<br />
						Ícone: 64 x 64 pixels<br />
					</small>
				</p>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from "axios";
	import Loading from "../Loading";
	import ImageCropper from "./ImageCropper.vue";
	import FileAdd from "../molecules/FileAdd.vue";
	export default {
		name: "logoManagement",
		data() {
			return {
				loading: false,
				file: null,
				message: "",
				cropping: false,
				croppedUrl: "",
        ext:''
			};
		},
		components: {
			Loading,
			ImageCropper,
			FileAdd,
		},
		props: {
			saveData: {
				type: Boolean,
				required: true,
			},
			siteId: {
				type: Number,
				required: true,
			},
		},
		methods: {
			uploadImage,
			submitFile,
			uploadCropped,
			getUrl,
			handleFile,
		},
		computed: {
			modeCrop() {
				return this.cropping;
			},
			verifyLogo() {
				//funcao para verificar se é pra mostrar só o input de upload ou nao
				if (
					this.$store.state.siteActive.logo ||
					this.$store.state.siteActive.logo_dark ||
					this.$store.state.siteActive.logo_mobile ||
					this.$store.state.siteActive.logo_dark_mobile
				) {
					return true;
				} else {
					return false;
				}
			},
			normalizeImage() {
				//deprecated
				//return process.env.CDN_URL + this.$store.state.siteActive.logo;
			},
		},
	};
	function getUrl(type) {
		var file = this.$store.state.siteActive[type]
		if(!file){
			return null
		}
		if (getExt(file) == 'svg'){
			return `${process.env.CONTAINER_URL}${file}`;
		}
		return `${process.env.CDN_URL}${file}`;
	}
	function getExt(str){
		if(str){
			str = str.toLowerCase().split(".");
			return str[str.length - 1];
		}
		else{
			return null
		}
	}
	function handleFile(file, type) {
		var handle = this.$refs[file];
		let str = handle.files[0].name.toLowerCase().split(".");
		this.ext = str[str.length - 1];
		if (
			this.ext == "jpeg" ||
			this.ext == "jpg" ||
			this.ext == "png" ||
			this.ext == "gif" ||
			this.ext == "svg"
		) {
			this.file = handle.files[0];
			this.uploadImage(type);
		} else {
			alert(
				"Arquivo " +
					this.$refs.uploadLogo.files[0].name +
					" não suportado. Selecione novamente"
			);
		}
	}
	/*
		deprecated
		function handleFileUpload() {
		  let str = this.$refs.uploadLogo.files[0].name.toLowerCase().split(".");
		  let ext = str[str.length - 1];
		  if (
		    ext == "jpeg" ||
		    ext == "jpg" ||
		    ext == "png" ||
		    ext == "gif" ||
		    ext == "svg"
		  ) {
		    this.file = this.$refs.uploadLogo.files[0];
		    this.uploadImage(ext);
		  } else {
		    alert(
		      "Arquivo " +
		        this.$refs.uploadLogo.files[0].name +
		        " não suportado. Selecione novamente"
		    );
		  }
		}*/
	function uploadCropped() {
    if(this.ext == 'svg'){
      this.$emit("back",true);
    }
    else{
      const url = this.croppedUrl;
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          var file = new File([blob], "newlogo.png", { type: "image/png" });
          this.file = file;
          this.uploadImage(this.cropping);
        });
    }
	}
	function uploadImage(type) {
		this.loading = true;
		this.message = "";
		let formData = new FormData();
		let token = this.$session.get("jwt");
		let file = this.file;
		let siteId = this.$session.get("siteId");
		formData.append("images[]", file);
		formData.append("siteId", this.siteId);
		axios({
			method: "post",
			url: `${process.env.ROOT_API}/api/site/${siteId}/image/upload`,
			data: formData,
			headers: {
				Authorization: "Bearer " + token,
				// 'Content-Type': 'application/x-www-form-urlencoded'
			},
		})
			.then((response) => {
				this.submitFile(type, response.data.file_source[0]);
			})
			.catch((response) => {
				console.log("Erro ao adicionar imagens");
			});
	}
	function submitFile(type, filePath) {
		let formData = new FormData();
		let token = this.$session.get("jwt");
		formData.append("file", filePath);
		formData.append("type", type);
		axios({
			method: "post",
			url: process.env.ROOT_API + "/api/site/" + this.siteId + "/logo/update",
			data: formData,
			headers: {
				Authorization: "Bearer " + token,
				// 'Content-Type': 'application/x-www-form-urlencoded'
			},
		})
			.then((response) => {
				this.message = response.data.message;
				//verify logo deu erro pq nao consegue pegar a function do computed.
				if (
					!this.$store.state.siteActive.logo &&
					!this.$store.state.siteActive.logo_dark &&
					!this.$store.state.siteActive.logo_mobile &&
					!this.$store.state.siteActive.logo_dark_mobile
				) {
					//se é a primeira vez que tá subindo o logo, atualiza todas!
					this.$store.commit("UPDATE_FILE_SITEACTIVE", {
						type: "logo",
						filePath: filePath,
					});
					this.$store.commit("UPDATE_FILE_SITEACTIVE", {
						type: "logo_mobile",
						filePath: filePath,
					});
					this.$store.commit("UPDATE_FILE_SITEACTIVE", {
						type: "logo_dark",
						filePath: filePath,
					});
					this.$store.commit("UPDATE_FILE_SITEACTIVE", {
						type: "logo_dark_mobile",
						filePath: filePath,
					});
					this.$store.commit("UPDATE_FILE_SITEACTIVE", {
						type: "favicon",
						filePath: filePath,
					});
				} else {
					var send = { type: type, filePath: filePath };
					this.$store.commit("UPDATE_FILE_SITEACTIVE", send);
				}
				//problema quando é a primeira vez
				if (this.cropping) {
					this.cropping = false;
				} else {
					this.cropping = type;
				}
				this.loading = false;
			})
			.catch(function () {
				console.log("Falha ao atualizar logo do site");
				this.loading = false;
			});
	}
</script>
<style scoped>
	.logo-item {
		margin: 0 auto;
		display: block;
		height: auto;
	}
	.current-logo {
		max-width: 150px;
		max-height: 100px;
	}
	.current-logo-mobile {
		max-width: 150px;
		max-height: 70px;
	}
	.current-favicon {
		max-width: 70px;
		max-height: 70px;
	}
	.succes-message {
		font-size: 0.8rem;
		color: var(--main-color);
	}
	.btn-secundario {
		color: #000;
	}
	.mode-dark {
		background: #000;
	}
	.mode-dark p {
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/organisms/LogoManagement.vue